module.exports = __webpack_public_path__ + "img/tips1_botlist5img3.67edea11.jpg";